var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loader"}},[_c('div',{staticClass:"text-center",staticStyle:{"padding":"10% 0px","position":"absolute","top":"10%","left":"45%"}},[_c('v-progress-circular',{attrs:{"color":"accent","size":"90","width":"6","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }